import * as React from "react";
import {AppState} from "../store/app_state";
import {Action, Dispatch} from "redux";
import {connect} from "react-redux";

import {createCustomerTutorialDispatcher} from "../dispatcher/customer_tutorial_dispatcher";
import {createCustomerTutorialActionCreator} from "../action/customer_tutorial_action";
import {CustomerTutorialState} from "../store/customer_tutorial_state";
import {ICustomerTutorialDispatcher} from "../dispatcher/customer_tutorial_dispatcher";

import CustomerTutorialComponent from "../component/customer/tutorial/customer_tutorial";
import {AuthState} from "../store/auth_state";
import {Customer} from "../../domain/model/customer";
import {OuterURL} from "src/config/view_const/outer_url";

interface IProps {
    state: CustomerTutorialState;
    authState: AuthState;
    dispatcher: ICustomerTutorialDispatcher;
    history: any;
}

interface IState {
}

export class CustomerTutorial extends React.Component <IProps, IState> {

    constructor(props: IProps) {
        super(props);
    }

    public render(): JSX.Element {

        const customer: Customer | null = this.props.authState.user && this.props.authState.user.customer;

        return (
            <CustomerTutorialComponent
                customer={customer}
                handleNextStep={this.handleNextStep}
            />
        )

    }

    private handleNextStep = (): void => {
        window.open(OuterURL.calendlyURL, '_blank');
        this.props.history.push("/customer");
    };

}

const mapStateToProps = (state: AppState) => {
    return {
        state: state.customerTutorialReducer,
        authState: state.authReducer,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {
        dispatcher: createCustomerTutorialDispatcher(dispatch, createCustomerTutorialActionCreator()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerTutorial);



// WEBPACK FOOTER //
// ./src/presentation/container/customer_tutorial_container.tsx